import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=5a47e6ca&scoped=true"
import script from "./Step1.vue?vue&type=script&lang=js"
export * from "./Step1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a47e6ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a47e6ca')) {
      api.createRecord('5a47e6ca', component.options)
    } else {
      api.reload('5a47e6ca', component.options)
    }
    module.hot.accept("./Step1.vue?vue&type=template&id=5a47e6ca&scoped=true", function () {
      api.rerender('5a47e6ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/Step1.vue"
export default component.exports